var $ = require('jquery');
var slick = require('slick-carousel');

function init() {
	$(document).ready(function(){
		$('.customer-logos').slick({
			slidesToShow: 4,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2000,
			arrows: true,
			dots: false,
			pauseOnHover: false,
			responsive: [
				{breakpoint: 950, settings: {slidesToShow: 4}},
				{breakpoint: 768, settings: {slidesToShow: 3}},
				{breakpoint: 550, settings: {slidesToShow: 2}},
				{breakpoint: 425, settings: {slidesToShow: 1}}
			]
		});
  });
}

module.exports = {
	init: init
}